import store from "@/store";
import {computed, ref} from "vue";
import api from "@/api/api";
import {executarCallbackAposFinalizacaoRequisicoesBackend, logout} from "@/helpers";

export function useGrupoComprasUsuario() {
  const grupos_compras = computed(() => store.getters["usuario/getGrupos"]);

  const grupo_compras_usuario = ref(null);

  function buscarGrupoComprasUsuario() {
    if (grupo_compras_usuario.value) {
      return;
    }

    api.get('grupo-compras-usuario')
      .then(resp => grupo_compras_usuario.value = resp.data.grupo)
      .catch(logout)
  }

  function selecionarGrupoComprasUsuarioNoTopBar() {
    if (!grupo_compras_usuario.value) {
      return;
    }

    store.dispatch('usuario/setGrupoCompras', grupo_compras_usuario.value.id);
  }

  function selecionarGrupoComprasPadraoNoTopBar() {
    if (!grupo_compras_usuario.value) {
      return;
    }

    store.dispatch('usuario/setGrupoCompras', Number(localStorage.getItem("config_grupo_compra_padrao")) || 1);
  }

  function gerenciarExibicaoGrupo({ exibir_grupo_dinamico }) {
    buscarGrupoComprasUsuario();

    if (exibir_grupo_dinamico) {
      executarCallbackAposFinalizacaoRequisicoesBackend(exibirGrupoComprasUsuario);
    } else {
      executarCallbackAposFinalizacaoRequisicoesBackend(ocultarGrupoComprasUsuario);
    }
  }

  function exibirGrupoComprasUsuario() {
    if (!grupo_compras_usuario.value) {
      return;
    }

    const grupos = grupos_compras.value;

    grupos.unshift({
      id: grupo_compras_usuario.value.id,
      descricao: grupo_compras_usuario.value.descricao,
      sigla: grupo_compras_usuario.value.sigla,
      grupo_compras_usuario: true,
    });

    store.dispatch("usuario/setGrupos", grupos);

    selecionarGrupoComprasUsuarioNoTopBar();
  }

  function ocultarGrupoComprasUsuario() {
    if (grupos_compras.value.every(item => !item.grupo_compras_usuario)) {
      return;
    }

    const grupos = grupos_compras.value.filter(item => !item.grupo_compras_usuario);
    store.dispatch("usuario/setGrupos", grupos);

    selecionarGrupoComprasPadraoNoTopBar();
  }

  return {
    gerenciarExibicaoGrupo,
  }
}
